export const common = {
  siteName: 'CSSBuy Spreadsheet',
  siteDomain: 'cssbuybr.run',
  mainSite: 'https://kaspreadsheet.com',
  language: 'Português',
  nav: {
    home: 'Início',
    products: 'Produtos',
    guides: 'Guias',
    review: 'Avaliação',
    shipping: 'Frete',
    qc: 'Controle de Qualidade',
    warehouse: 'Armazém',
    sellers: 'Vendedores',
    comparisons: 'Comparações',
    safety: 'Segurança',
    about: 'Sobre',
    contact: 'Contato',
  },
  buttons: {
    explore: 'Explorar CSSBuy Spreadsheet',
    buyNow: 'Comprar Agora',
    viewGuides: 'Ver Guias de Compra',
    mainSite: 'CSSBuy Spreadsheet',
    shopNow: 'Comprar Agora',
    readMore: 'Ler Mais',
    backToHome: 'Voltar ao Início',
  },
  categories: {
    title: 'Categorias de Produtos',
    subtitle: 'Navegue por produtos confiáveis por categoria em nosso site principal',
    shoes: 'Sapatos',
    hoodiesSweaters: 'Moletom / Suéteres',
    tShirts: 'Camisetas',
    jackets: 'Jaquetas',
    pantsShorts: 'Calças / Shorts',
    headwear: 'Chapéus',
    sets: 'Conjuntos',
    underwear: 'Roupa Íntima / Cuecas',
    jersey: 'Jersey',
    accessories: 'Acessórios',
    bags: 'Bolsas',
    belts: 'Cintos',
    perfumes: 'Perfumes',
    otherStuff: 'Outros',
  },
  hero: {
    h1: 'CSSBuy Spreadsheet: Encontre Produtos, Vendedores e Guias para Comprar da China',
    description:
      'Procurando um CSSBuy Spreadsheet para encontrar produtos, vendedores e recursos de compra com mais facilidade? Encontre guias, comparações, informações sobre QC, armazém, frete e dicas práticas para pesquisar melhor antes de comprar.',
  },
  popularResources: {
    title: 'Recursos Populares',
    subtitle: 'Tudo que você precisa saber sobre a CSSBuy',
    items: {
      spreadsheet: 'CSSBuy Spreadsheet',
      review: 'Avaliação CSSBuy',
      shipping: 'Custo de Frete CSSBuy',
      coupon: 'Cupom CSSBuy',
      discount: 'Código de Desconto CSSBuy',
      warehouse: 'Armazém CSSBuy',
      legit: 'CSSBuy é Confiável?',
      qc: 'QC CSSBuy',
      sellers: 'Vendedores CSSBuy',
    },
  },
  ctaSection: {
    title: 'Pronto para Começar a Comprar?',
    description:
      'Visite nossa loja principal para navegar pela planilha CSSBuy completa com produtos verificados, vendedores confiáveis e ofertas exclusivas.',
    button1: 'CSSBuy Spreadsheet',
    button2: 'Comprar Agora',
  },
  footer: {
    disclaimer:
      'Este site é um recurso informativo independente e não é oficialmente afiliado ou endossado pela CSSBuy.',
    quickLinks: 'Links Rápidos',
    resources: 'Recursos',
    legal: 'Legal',
    editorial: 'Política Editorial',
    disclaimerPage: 'Aviso Legal',
    privacy: 'Política de Privacidade',
    terms: 'Termos de Serviço',
    copyright: '© {year} cssbuybr.run. Todos os direitos reservados.',
  },
  article: {
    published: 'Publicado',
    updated: 'Atualizado',
    minRead: 'min de leitura',
    tableOfContents: 'Sumário',
    relatedArticles: 'Artigos Relacionados',
    faq: 'Perguntas Frequentes',
  },
  home: {
    latestGuides: 'Guias Recentes',
    latestGuidesSubtitle: 'Explore nossos guias e recursos aprofundados para comprar com mais inteligência',
    pillarTitle: 'Guias do CSSBuy Spreadsheet',
    pillarSubtitle: 'Artigos pilares aprofundados para ajudar você a comprar com mais inteligência na CSSBuy',
  },
  meta: {
    homeTitle: 'CSSBuy Spreadsheet: Produtos, Vendedores e Guias de Compra 2026',
    homeDescription:
      'O centro de recursos completo da CSSBuy Spreadsheet. Encontre produtos, vendedores, guias de QC, informações de frete, detalhes de armazém e dicas de compra para a CSSBuy em 2026.',
  },
  products: {
    title: 'Produtos em Destaque',
    subtitle: 'Navegue pelos produtos selecionados da nossa planilha. Clique em qualquer item para ver detalhes e comprar em nosso site parceiro.',
    viewAll: 'Ver Todos os Produtos',
    pageTitle: 'Todos os Produtos',
    pageDescription: 'Navegue por todos os produtos selecionados da nossa planilha. Clique em qualquer item para ver detalhes e comprar em nosso site parceiro.',
    items: 'produtos',
    categories: 'categorias',
    all: 'Todos',
  },
};